
export function addLeftPad0(
  number: number,
  condition: (number: number) => boolean = number => number < 10
): string {
  return (condition(number) ? '0' : '') + number.toString(10);
}
